import axios from 'axios'
import library from '../../../utils/Library'

export const deleteCustomerUserCorp = async (params) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('corp_customer') +
    '/deleteCustomerUserCorpCustomer'

  return await axios({
    url: URL,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: params
  })
}
